module.exports = __webpack_public_path__ + "img/facebook.ac0b14e7.svg";